import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeTypeParams extends DefaultHttpHeaders {
  /** Unique identifier of building type */
  homeTypeCode: string;
}

@Injectable()
export class HomeTypeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home type by code
   * Service for obtaining home type by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeTypeById
   */
  homeType(params: HomeTypeParams): Observable<ParameterResult> {
    const pathParams = {
      homeTypeCode: params.homeTypeCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/homeType/${pathParams.homeTypeCode}`,
    });
  }
}
